/**
 * returns filter by group ids
 * @param groupIds
 */
const groupFilter = (groupIds: string[] | null | undefined) => {
    let result: any = [
        {
            groupIds: {
                $exists: false
            }
        },
        {
            groupIds: []
        },
    ];
    if (groupIds && groupIds.length) {
        result = [
            {
                groupIds: {
                    $containsAny: groupIds
                }
            },
            ...result
        ];
    }
    return {$or: result};
}

export { groupFilter }